module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Black.c4b9881e.png";